import { useFirebase } from 'components/Firebase/index.js';
import { handleCall } from 'utils/index.js';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

const sortOrganizations = (org, org2) => (org.title > org2.title ? 1 : -1);

const useOrganizations = ({ enabled = true, ...options } = {}) => {
  const firebase = useFirebase();
  const authUser = useSelector((state) => state.sessionState.authUser);
  const masqueradeMode = useSelector((state) => state.ui.masqueradeMode);

  const currentUser = firebase.auth.currentUser;
  const isSignedIn = Boolean(currentUser);

  const { data: organizations = [], ...restQueryData } = useQuery({
    queryKey: ['/currentUser/organizations', authUser?.uid, masqueradeMode?.org?.id],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      if (masqueradeMode?.org) {
        const { id, title } = masqueradeMode.org;
        const { error, body } = await handleCall(agent, { url: `/o/${id}/features/lvsDashboard` });
        if (error) {
          throw new Error(error);
        }
        return [{
          id,
          title,
          features: body || {},
          clientId: masqueradeMode.org.clientId,
        }];
      }
      const { error, body } = await handleCall(agent, { url: '/currentUser/organizations' });
      if (error) {
        throw new Error(error);
      }

      return body?.organizations ?? [];
    },
    enabled: Boolean(authUser?.uid) && isSignedIn && enabled,
    ...options,
  });

  return { data: organizations.sort(sortOrganizations), ...restQueryData };
};

export default useOrganizations;
